import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator, endpointQuery } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const actions = createActions({
  SEARCH_TILE: {
    GET: (skip, query) => ({ skip, query }),
    API: {
      GET: apiResourceActionCreator('searchTileResult')
    }
  }
})

export const apiAction = (authToken, skip, query) => commonApiActions.authenticated.get(`${API_ENDPOINT}${endpointQuery({ ...(query || {}), skip })}`, authToken, actions.searchTile.api.get)

export function* getSearchTile(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload.skip, action.payload && action.payload.query));
}

const configuration = {
  name: 'get',
  action: actions,
  sagas: getSearchTile,
  reducers: {
    request: (state, action) => {
      return Object.assign({}, state, {
        isFetching: true
      });
    },
    success: (state, action) => {
      return Object.assign({}, state, {
        isFetching: false,
        searchTileResult: action.payload.searchTileResult,
        error: null
      });
    },
    failed: (state, action) => {
      return Object.assign({}, state, {
        isFetching: false,
        isLoadingMore: false,
        error: action.payload.error
      });
    }
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/search-tile/configurations/get.js